import axios from 'axios'
import Requester from './Requester'

export const apiLimitReturned = 10
export const requesterConfigurationMethods = {
  GET_TOKEN: 'CONFIGURATION_GET_TOKEN',
  GET_CONTEXT: 'CONFIGURATION_GET_CONTEXT',
  GET_CONFIG: 'CONFIGURATION_GET_CONFIG',
  GET_SILENT_CONFIG: 'CONFIGURATION_GET_SILENT_CONFIG',
  GET_AUTOMATIC_VALIDATION_SETTINGS: 'CONFIGURATION_GET_AUTOMATIC_VALIDATION_SETTINGS',
  GET_PRICING_POLICY: 'CONFIGURATION_GET_PRICING_POLICY'
}

const getDomainUrl = () => {
  if (window.location.hostname.indexOf('localhost') !== -1) {
    return null
  }
  return window.location.href.replace(window.location.pathname, '')
}

/**
 * The Request class allows you to centralize calls to the outside of the application, including the server
 */
class RequesterConfiguration extends Requester {
  /**
   * Réalise des appels vers l'API
   *
   * @param {string} action le nom de l'action à réaliser
   * @param {*} params un objet de paramètres
   * @static
   * @return {Promise} une promesse en général avec les données de retour
   */

  static get = (action, params, redirectMessage) => {
    if (action === requesterConfigurationMethods.GET_SILENT_CONFIG) {
      const requestSettings = RequesterConfiguration.getRequest({
        urlApi: 'urlSelling',
        url: `/opportunities/settings/current`,
        params: {},
        redirectMessage
      })

      const requestCurrentPricingPolicy = RequesterConfiguration.getRequest({
        urlApi: 'urlScoring',
        url: `/pricing-policies/current/2`,
        params: {},
        redirectMessage
      })
      const requests = [requestSettings, requestCurrentPricingPolicy]

      return new Promise((resolve, reject) => {
        axios
          .all(requests)
          .then(
            axios.spread((settingsResponse, pricingPolicyResponse) => {
              if (settingsResponse.error) {
                if (settingsResponse.error.message) reject(settingsResponse.error.message)

                reject(settingsResponse.error)
              }

              if (pricingPolicyResponse.error) {
                if (pricingPolicyResponse.error.message) reject(pricingPolicyResponse.error.message)

                reject(pricingPolicyResponse.error)
              }

              const { opportunitySettings } = settingsResponse
              const { pricingPolicy } = pricingPolicyResponse

              const response = {
                opportunitySettings,
                pricingPolicy
              }

              resolve(response)
            })
          )
          .catch(error => {
            reject(error)
          })
      })
    }

    if (action === requesterConfigurationMethods.GET_CONFIG) {
      const requestCampaign = RequesterConfiguration.getRequest({
        urlApi: 'urlSelling',
        url: `/campaigns/current`,
        params: {},
        redirectMessage
      })

      const requestConfig = RequesterConfiguration.getRequest({
        urlApi: 'urlConfigurator',
        url: `/provider-configurations/current`,
        params: {},
        redirectMessage
      })

      const requestSettings = RequesterConfiguration.getRequest({
        urlApi: 'urlSelling',
        url: `/opportunities/settings/current`,
        params: {},
        redirectMessage
      })

      const requestCurrentPricingPolicy = RequesterConfiguration.getRequest({
        urlApi: 'urlScoring',
        url: `/pricing-policies/current/2`,
        params: {},
        redirectMessage
      })

      const requests = [
        requestCampaign,
        requestConfig,
        requestSettings,
        requestCurrentPricingPolicy
      ]

      return new Promise((resolve, reject) => {
        axios
          .all(requests)
          .then(
            axios.spread(
              (campaignResponse, configResponse, settingsResponse, pricingPolicyResponse) => {
                if (campaignResponse.error) {
                  if (campaignResponse.error.message) reject(campaignResponse.error.message)

                  reject(campaignResponse.error)
                }
                if (configResponse.error) {
                  if (configResponse.error.message) reject(configResponse.error.message)

                  reject(configResponse.error)
                }
                if (settingsResponse.error) {
                  if (settingsResponse.error.message) reject(settingsResponse.error.message)

                  reject(settingsResponse.error)
                }
                if (pricingPolicyResponse.error) {
                  if (pricingPolicyResponse.error.message)
                    reject(pricingPolicyResponse.error.message)

                  reject(pricingPolicyResponse.error)
                }

                const { providerConfiguration } = configResponse
                const { campaign } = campaignResponse
                const { opportunitySettings } = settingsResponse
                const { pricingPolicy } = pricingPolicyResponse

                const response = {
                  campaign,
                  providerConfiguration,
                  opportunitySettings,
                  pricingPolicy
                }

                resolve(response)
              }
            )
          )
          .catch(error => {
            reject(error)
          })
      })
    }

    if (action === requesterConfigurationMethods.GET_CONTEXT) {
      return RequesterConfiguration.getRequest({
        urlApi: 'urlIdentity',
        url: '/campaigns/current/context'
      })
    }

    if (action === requesterConfigurationMethods.GET_TOKEN) {
      const { token, pointOfSaleId } = params

      const domain = getDomainUrl()

      return RequesterConfiguration.post({
        urlApi: 'urlIdentity',
        url: '/auth/campaigns/sign-in',
        params: { id: token, pointOfSaleId: pointOfSaleId && String(pointOfSaleId), domain }
      })
    }

    if (action === requesterConfigurationMethods.GET_PRICING_POLICY) {
      return RequesterConfiguration.getRequest({
        urlApi: 'urlScoring',
        url: `/pricing-policies/current/2`,
        params: {},
        redirectMessage
      })
    }

    if (action === requesterConfigurationMethods.GET_AUTOMATIC_VALIDATION_SETTINGS) {
      const { id, automaticValidationId } = params

      return RequesterConfiguration.getRequest({
        urlApi: 'urlScoring',
        url: `/pricing-policies/${String(id)}/automatic-validations/${String(
          automaticValidationId
        )}`,
        params: {},
        redirectMessage
      })
    }

    return null
  }
}

export default RequesterConfiguration
